<template>
    <div class="container-fluid px-0">

        <AuthNav></AuthNav>

        <NavButtons light-btns></NavButtons>

    </div>

    <div class="row">
        <div class="col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-xl-6 offset-xl-3 mb-3">
            <RestrictedActionView action="revoke_session_from_email" :data="data" :uid="uid"></RestrictedActionView>
        </div>
    </div>

</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {useAuthStore} from "@/stores/auth-store.js";
import {useAppHelpers} from "@/composables/useAppHelpers.js";
import NavButtons from "@/components/NavButtons.vue";
import AuthNav from "@/views/Auth/AuthNav.vue";
import {useRouter} from "vue-router";
import RestrictedActionView from "@/components/GenericModalAndViews/RestrictedActionView.vue";

const props = defineProps({
    uid: String,
    session_id: String,
});

const auth = useAuthStore();
const helper = useAppHelpers();
const router = useRouter();

const data = ref({});

onMounted(async () => {
    if (!props.uid || !props.session_id) {
        await router.push({name: 'home'});
    }
	data.value = {
		uid: props.uid,
		session_id: props.session_id
	};
});


</script>

<style scoped lang="scss"></style>
